"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/** Shared empty state: icon + message when a list has no items. Use in Feed, Shop, Calendar, Staff, etc. */
const EmptyState = ({ message, icon, style }) => ((0, jsx_runtime_1.jsxs)("div", { style: {
        padding: 40,
        textAlign: 'center',
        color: '#71717a',
        ...style,
    }, role: "status", "aria-label": message, children: [icon && ((0, jsx_runtime_1.jsx)("div", { style: { marginBottom: 12, display: 'flex', justifyContent: 'center', opacity: 0.5 }, children: icon })), (0, jsx_runtime_1.jsx)("p", { style: { margin: 0 }, children: message })] }));
exports.default = EmptyState;
